import React from "react";
import { Link } from "react-router-dom";

function Home() {
  return (
    <div className="home">
      <h1 className="primary-color" style={{fontSize: "36px"}}>De-Med</h1>
      <p>(Deprescribing Medications)</p>
      <p className="primary-color" style={{fontSize: "28px"}}>Empowering Safe and Appropriate Medication Use in the Elderly</p>
      <p className="center home-content">
        Welcome to De-Med, your trusted resource for promoting safe and
        appropriate medication <br /> practices in the elderly population. We
        understand the unique challenges that come with managing <br /> medications for
        older adults, and our mission is to provide a comprehensive solution
        that focuses <br /> on timely identification of potentially inappropriate
        medications.
      </p>
      <Link to="/drugs"><button className="btn">START</button></Link>
    </div>
  );
}

export default Home;
